import { Component, ViewChild,AfterViewInit } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform,ViewController, Content } from 'ionic-angular';

import { Company } from '../../models/company-config';
import { PageBase } from '../page-base';
import { DataProvider } from '../../providers/data/data';
import { CompanyConfigProvider } from '../../providers/company-config/company-config';
import { Address } from '../../models/address';
import { BasketProvider } from '../../providers/basket/basket';
import { BasketPage } from '../basket/basket';

declare const google;

@IonicPage()
@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html'
})



export class ContactPage extends PageBase {
 @ViewChild(Content) content: Content;
 map: any;

  company: Company;
  company1: any;
  storeLocations: Array<Address>;

  showPrice: boolean;
  showOrder: boolean;

  constructor(
    private companyConfigProvider: CompanyConfigProvider,
    private basket: BasketProvider,
    public viewCtrl: ViewController,
    private navCtrl: NavController
  ) {
    super();

    companyConfigProvider.canSeePrice().then(x => {
      this.showPrice = x;
    });

    companyConfigProvider.canSubmitOrder().then(x => {
      this.showOrder = x;
      this.content?.resize();
    });

    companyConfigProvider.getCompany().then(company => {
      this.company = company;
      this.company1 = company;
      this.storeLocations = company.contact_details.addresses.filter(x => x.type.name == "STORE_LOCATION");
    });
  }


ionViewDidLoad(){
	setTimeout(() => {
		let y = this.company;
	    let posCompany = {
	    	lat: parseFloat(y.geolocation_lat),
	    	lng: parseFloat(y.geolocation_lng)
	    }
		let mapElem = document.getElementById('mymap');


	    this.map = new google.maps.Map(mapElem, {
	        zoom: parseFloat(y.geolocation_zoom),
	        center: posCompany,
	        mapTypeId: 'roadmap'
	    });
	    this.map.setCenter(posCompany);

		let marker = new google.maps.Marker({
			position: new google.maps.LatLng(posCompany.lat, posCompany.lng),
			map: this.map
		});


       }, 250);

}

  /**
   * Opens Map app
   */
  private openMap() {
    // ios
    if (this.platform.is('ios')) {
      window.open('maps://?q=' + this.getCompanyAddress(), '_system');
    };
    // android
    if (this.platform.is('android')) {
      window.open('geo://?q=' + this.getCompanyAddress(), '_system');
    };
  }

  /**
   * Returns pretty version of address.
   */
  private getCompanyAddress() {
    return this.storeLocations[0].street + ' ' + this.storeLocations[0].number + ' ' + this.storeLocations[0].city;
  }

  /**
  * Navigates to the basket page.
  */
  private navigateToBasket() {
    this.navCtrl.push(BasketPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts